import { Icon } from './Icon';

interface AppHeaderProps {
  title: string;
  onHome?: () => void;
  backLabel?: string;
  onBack?: () => void;
}

export function AppHeader({ title, onHome, backLabel = 'Go back', onBack }: AppHeaderProps) {
  return (
    <header className="app-header">
      <div className="header-side">
        {onBack && (
          <button className="icon-button" type="button" onClick={onBack} aria-label={backLabel}>
            <Icon name="back" />
          </button>
        )}
        {!onBack && onHome && (
          <button className="icon-button" type="button" onClick={onHome} aria-label="Go to the home screen">
            <Icon name="home" />
          </button>
        )}
      </div>
      <h1>{title}</h1>
      <div className="header-side" />
    </header>
  );
}

